import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { CommonBookingAncillariesModule, CommonBookingComponentsModule } from '@fcom/common-booking';
import { UiTranslateModule } from '@fcom/ui-translate';
import { UiComponentsModule } from '@fcom/ui-components';
import { CmsModule } from '@fcom/cms/components';
import { ComponentsModule, DirectiveModule, FinFormsModule, PipesModule } from '@fcom/common';
import { FeedbackWidgetModule } from '@fcom/common/components/feedback-widget/feedback-widget.module';

import { ManageBookingCommonModule } from '../common/booking-common.module';
import { PassengerDetailsGuard } from './services/passenger-details.guard';
import { ManageBookingPassengerDetailsRouteComponent } from './routes/passenger-details-route.component';
import { MmbPassengerInfoComponent } from './components/mmb-passenger-info/mmb-passenger-info.component';
import { ManageBookingTierBenefitsComponent } from './components/tier-benefits/tier-benefits.component';
import { ManageBookingPassengerTicketsComponent } from './components/passenger-tickets/passenger-tickets.component';
import { ManageBookingPassengerEMDsComponent } from './components/passenger-emds/passenger-emds.component';
import { ManageBookingPassengerOrderEticketComponent } from './components/passenger-order-eticket/passenger-order-eticket.component';
import { PassengerDetailsDeactivateGuard } from './services/passenger-details-deactivate.guard';

@NgModule({
  imports: [
    CommonModule,
    ComponentsModule,
    CmsModule,
    PipesModule,
    ReactiveFormsModule.withConfig({
      callSetDisabledState: 'whenDisabledForLegacyCode',
    }),
    DirectiveModule,
    UiTranslateModule,
    UiComponentsModule,
    ManageBookingCommonModule,
    CommonBookingComponentsModule,
    CommonBookingAncillariesModule,
    FeedbackWidgetModule,
    FinFormsModule,
  ],
  declarations: [
    ManageBookingPassengerDetailsRouteComponent,
    MmbPassengerInfoComponent,
    ManageBookingTierBenefitsComponent,
    ManageBookingPassengerTicketsComponent,
    ManageBookingPassengerEMDsComponent,
    ManageBookingPassengerOrderEticketComponent,
  ],
  exports: [ManageBookingPassengerDetailsRouteComponent, MmbPassengerInfoComponent],
  providers: [PassengerDetailsGuard, PassengerDetailsDeactivateGuard],
})
export class ManageBookingViewPassengersModule {}
